import { __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
export var checkStaffHasExternalStaff = function (staffIds) {
    if (staffIds === void 0) { staffIds = []; }
    return __awaiter(void 0, void 0, Promise, function () {
        var externalStaffs, staffMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(staffIds === null || staffIds === void 0 ? void 0 : staffIds.length)) {
                        return [2, false];
                    }
                    return [4, app.dataLoader('@common.externalList').load()];
                case 1:
                    externalStaffs = _a.sent();
                    staffMap = externalStaffs.reduce(function (map, staff) {
                        map[staff.id] = staff;
                        return map;
                    }, {});
                    return [2, staffIds.some(function (id) { var _a; return (_a = staffMap[id]) === null || _a === void 0 ? void 0 : _a.external; })];
            }
        });
    });
};
export var checkStaffCanShiftAndAddNode = function (submitNode, nodeConfigId) {
    var _a, _b, _c;
    if ((_a = submitNode === null || submitNode === void 0 ? void 0 : submitNode.externalStaffConfig) === null || _a === void 0 ? void 0 : _a.shiftAcceptOwner) {
        return ((_c = (_b = submitNode === null || submitNode === void 0 ? void 0 : submitNode.externalStaffConfig) === null || _b === void 0 ? void 0 : _b.shiftPlanNodeId) === null || _c === void 0 ? void 0 : _c.length) ? submitNode.externalStaffConfig.shiftPlanNodeId.includes(nodeConfigId)
            : true;
    }
    return false;
};
export var flowPlanNodeFormItemStyle = { marginBottom: '10px' };
